import React, { Component } from 'react';
import dynamicPortal from '../utils/dynamicPortal';
import Lines from '../components/Haltes/Lines'

export class HalteLinesPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-halte-lines', (config) => (
      <Lines config={config} />
    ));
  }
}

export default HalteLinesPortal;


// WEBPACK FOOTER //
// ./src/portals/HalteLinesPortal.js